import api from "@/api";
import type { EmployeeTitleFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";
import type { LoadingType, NullableBoolean } from "@/types";
import { computed, onMounted, ref } from "vue";

const employeeTitles = ref<EmployeeTitleFragment[]>([]);
const loading = ref<LoadingType>("none");

export function useEmployeeTitles() {
  onMounted(async () => {
    if (loading.value === "none") {
      refetch("loading");
    }
  });

  const refetch = async (loadingValue: LoadingType = "refetching") => {
    loading.value = loadingValue;

    employeeTitles.value = await api.employeesTitles.getTitles();
    loading.value = "loaded";
  };

  const employeeTitlesList = computed(() => {
    return employeeTitles.value.map((item) => {
      return {
        id: item.id,
        title: item.title,
      } as IMultiSelectItem;
    });
  });

  const employeeTitlesAsOption = computed(() => {
    return employeeTitles.value.map((item) => {
      return {
        value: item.id,
        title: item.title,
      } as IOption;
    });
  });

  const isEmpty = computed<NullableBoolean>(() => {
    if (loading.value === "none" || loading.value === "loading") {
      return null;
    }

    return employeeTitles.value.length === 0;
  });

  return {
    employeeTitles,
    employeeTitlesList,
    employeeTitlesAsOption,
    loading,
    isEmpty,
    refetch,
  };
}
